import PlaceholderPage from '../components/PlaceholderPage';

export default function EvetCert() {
  return (
    <PlaceholderPage
      title="E-VET CERT"
      description="Electronic veterinary certificate lookup and verification lands here."
    />
  );
}
